import { render, staticRenderFns } from "./veStuYyprojectYy.vue?vue&type=template&id=4c8d732b&scoped=true"
import script from "./veStuYyprojectYy.vue?vue&type=script&lang=js"
export * from "./veStuYyprojectYy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d732b",
  null
  
)

export default component.exports